import { CartonReturnConstants } from '../constants';

export function Reverse(state = { items: [], loading: false }, action) {
    switch (action.type) {

        case CartonReturnConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };

        case CartonReturnConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };

        case CartonReturnConstants.GETALL_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.datas     // ResponseData directly UI में जाएगा
            };

        case CartonReturnConstants.GETALL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}